import { render, staticRenderFns } from "./impact-form-content.vue?vue&type=template&id=4ed04a66&scoped=true&"
import script from "./impact-form-content.vue?vue&type=script&lang=js&"
export * from "./impact-form-content.vue?vue&type=script&lang=js&"
import style0 from "./impact-form-content.vue?vue&type=style&index=0&id=4ed04a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed04a66",
  null
  
)

export default component.exports